export const applications = [
    {
        id: 1,
        company: "Curbeto",
        jobTitle: "Lead UX Researcher",
        location: "London",
        salaryRange: "$3000+/m",
        jobDuration: "Contract",
        jobType: "Remote",
        date: "10 Nov, 2021"
    },
    {
        id: 2,
        company: "Curbeto",
        jobTitle: "Lead UX Researcher",
        location: "London",
        salaryRange: "$3000+/m",
        jobDuration: "Contract",
        jobType: "Remote",
        date: "10 Nov, 2021"
    },
    {
        id: 3,
        company: "Curbeto",
        jobTitle: "Lead UX Researcher",
        location: "London",
        salaryRange: "$3000+/m",
        jobDuration: "Contract",
        jobType: "Remote",
        date: "10 Nov, 2021"
    },
    {
        id: 4,
        company: "Curbeto",
        jobTitle: "Lead UX Researcher",
        location: "London",
        salaryRange: "$3000+/m",
        jobDuration: "Contract",
        jobType: "Remote",
        date: "10 Nov, 2021"
    },
    {
        id: 5,
        company: "Curbeto",
        jobTitle: "Lead UX Researcher",
        location: "London",
        salaryRange: "$3000+/m",
        jobDuration: "Contract",
        jobType: "Remote",
        date: "10 Nov, 2021"
    },
    {
        id: 6,
        company: "Curbeto",
        jobTitle: "Lead UX Researcher",
        location: "London",
        salaryRange: "$3000+/m",
        jobDuration: "Contract",
        jobType: "Remote",
        date: "10 Nov, 2021"
    },
    {
        id: 7,
        company: "Curbeto",
        jobTitle: "Lead UX Researcher",
        location: "London",
        salaryRange: "$3000+/m",
        jobDuration: "Contract",
        jobType: "Remote",
        date: "10 Nov, 2021"
    },
    {
        id: 8,
        company: "Curbeto",
        jobTitle: "Lead UX Researcher",
        location: "London",
        salaryRange: "$3000+/m",
        jobDuration: "Contract",
        jobType: "Remote",
        date: "10 Nov, 2021"
    }
];
